import { apiSlice } from '../app/api/apiSlice';

export const errorTrackingApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    addErrorTracking: builder.mutation({
      query: (newErrorTracking)=>({
        url: '/ErrorTracking',
        method: 'post',
        body: newErrorTracking
      }),
      invalidatesTags: ["ErrorTrackingList", "ErrorTrackingListWithRelatedTransactions","userMetrics", "transactions"]
    }),
    updateErrorTracking: builder.mutation({
      query: (updatedErrorTracking)=>({
        url: '/ErrorTracking',
        method: 'put',
        body: updatedErrorTracking
      }),
      invalidatesTags: ["ErrorTrackingList","ErrorTrackingListWithRelatedTransactions", "userMetrics", "transactions", "transactionDetails"]
    }),
    getErrorReasons: builder.query({
      query: ()=>({
        url: '/ErrorTracking',
        method: 'get'
      }),
      providesTags: ["ErrorReasons"]
    }),
    getErrorTrackingPaged: builder.query({
      query: (params)=>({
        url: `/ErrorTracking/paged?${new URLSearchParams(params).toString()}`,
        method: 'get'
      }),
      providesTags: ["ErrorTrackingList"]
    }),
    getErrorTrackingPagedWithRelatedTransactions: builder.query({
      query: (params)=>({
        url: `/ErrorTracking/paged-with-related-transactions?${new URLSearchParams(params).toString()}`,
        method: 'get'
      }),
      providesTags: ["ErrorTrackingListWithRelatedTransactions"]
    }),
    deleteErrorTracking: builder.mutation({
      query: (errorTrackingId)=>({
        url: `/ErrorTracking/${errorTrackingId}`,
        method: 'delete'
      }),
      invalidatesTags: ["ErrorTrackingList", "ErrorTrackingListWithRelatedTransactions", "userMetrics", "transactions"]
    })
  })
})

export const {
  useAddErrorTrackingMutation,
  useGetErrorReasonsQuery,
  useUpdateErrorTrackingMutation,
  useGetErrorTrackingPagedWithRelatedTransactionsQuery,
  useGetErrorTrackingPagedQuery,
  useDeleteErrorTrackingMutation
} = errorTrackingApi;
